'use client';

/** Dismissible page-level error toast, pinned to the safe-area bottom-right. */

import React from 'react';

export function ChatErrorToast({
  error,
  onDismiss,
}: {
  error: string;
  onDismiss: () => void;
}) {
  return (
    <div className="fixed bottom-[calc(1rem+env(safe-area-inset-bottom))] right-[calc(1rem+env(safe-area-inset-right))] bg-destructive text-destructive-foreground px-6 py-4 rounded-lg shadow-xl max-w-[calc(100vw-2rem)] sm:max-w-sm border border-destructive/20 animate-in slide-in-from-bottom-5">
      <div className="flex justify-between items-start gap-4">
        <p className="text-sm font-medium">{error}</p>
        <button
          onClick={onDismiss}
          className="text-destructive-foreground hover:opacity-75 font-bold transition-opacity"
        >
          ×
        </button>
      </div>
    </div>
  );
}
